import type { ReactNode } from 'react';

export const symbol_water_damage: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M261-220h438v-377L480-765 261-597v377Zm0 60q-24.75 0-42.37-17.63Q201-195.25 201-220v-332l-101 78q-9.61 8-21.8 6Q66-470 58-480.37q-8-9.63-6.06-21.82Q53.89-514.38 64-522l380-291q17-12 36-12t36 12l381 291q10 8 11.5 20t-6.5 22q-8 10-20 12t-22-6l-101-78v332q0 24.75-17.62 42.37Q723.75-160 699-160H261Zm268.5-190.56Q550-371.13 550-400q0-26-10-46t-60-92q-50 72-60 92t-10 46q0 28.87 20.59 49.44Q451.18-330 480.09-330t49.41-20.56ZM480-400Z"
		/>
	</svg>
);
